var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class SingleProject extends Component {
    constructor() {
        super('SingleProject', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('body').on('click', '.btn-info:not(.is-active)', (event, button) => {
                event.preventDefault();
                this.openInformations();
            });
            $('body').on('click', '#project-container .btn-close, .single-project .btn-close', (event, button) => {
                event.preventDefault();
                this.closeInformations();
            });
            $(window).on('scroll', () => {
                if ($(window).width() < 992)
                    return;
                this.closeInformations();
            });
            $('#project-container').on('scroll', () => {
                if ($(window).width() < 992)
                    return;
                this.closeInformations();
            });
            $(window).on('scroll', () => {
                SingleProject.spyVideo();
            });
            $('#project-container').on('scroll', () => {
                SingleProject.spyVideo();
            });
            SingleProject.spyVideo();
            this.success();
        });
    }
    openInformations() {
        $('.btn-info').addClass('is-active');
        $('.project-informations').addClass('is-opened');
    }
    closeInformations() {
        $('.btn-info').removeClass('is-active');
        $('.project-informations').removeClass('is-opened');
    }
    static spyVideo() {
        const video = $('video');
        if (video.length == 0)
            return;
        if (video.viewportPosition().y < $(window).height() + 100 && video.viewportPosition().y + video.height() > 100) {
            video.get(0).play();
        }
        else {
            video.get(0).pause();
        }
    }
}
